import { ApiBase } from "~/extensions/api";
import { Log } from "~/extensions/utils";
const log = Log.create("PasswordApi");
export class PasswordApi extends ApiBase {
    changeHtml() {
        return this.api.get("message/password/change");
    }
    completeHtml() {
        return this.api.get("message/password/change/complete");
    }
    change(command) {
        return this.request(command);
    }
}
